import http from '@/http/aisea/axios'
const resource = "/enterprises/crews";

export default {

  fetch(enterpriseCrewId) {
    return http.get(`${resource}/${enterpriseCrewId}/accounts`);
  },

  add(enterpriseCrewId,payload) {
    return http.post(`${resource}/${enterpriseCrewId}/accounts`, payload);
  },

  update(enterpriseCrewId, enterpriseCrewAccountId, payload) {
    return http.put(`${resource}/${enterpriseCrewId}/accounts/${enterpriseCrewAccountId}`, payload);
  },

  delete(enterpriseCrewId, enterpriseCrewAccountId) {
    return http.delete(`${resource}/${enterpriseCrewId}/accounts/${enterpriseCrewAccountId}`);
  },
};
